import { render, staticRenderFns } from "./EditBrandTreeAsJsonDialog.vue?vue&type=template&id=5c3d05f3&scoped=true"
import script from "./EditBrandTreeAsJsonDialog.vue?vue&type=script&lang=js"
export * from "./EditBrandTreeAsJsonDialog.vue?vue&type=script&lang=js"
import style0 from "./EditBrandTreeAsJsonDialog.vue?vue&type=style&index=0&id=5c3d05f3&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3d05f3",
  null
  
)

export default component.exports